import React from 'react'
import useTooltip from '../../../hooks/useTooltip'
import './FolderCmd.css'

const FolderCmd = ({children, renamemode = false, tooltip, ...rest}) => {
  const {onMouseEnter, onMouseLeave, showTooltip} = useTooltip({
    showDelay: 600,
    hideDelay: 600
  });


  return (
    <div className='folderCmdWrapper' 
         onMouseEnter={onMouseEnter} 
         onMouseLeave={onMouseLeave}
         style={{opacity: renamemode ? 0.5 : 1}}>

      <button className='folderCmdButton' {...rest}>{children}</button>

      {showTooltip && tooltip && ( 
        <div className='folderCmdTooltip'>
          {tooltip}
        </div>
       )}
    </div>
  )
}

export default React.memo(FolderCmd);